import {RequestOptions, XHRBackend} from '@angular/http';
import {NotificationsService} from 'app/modules/core/services/index';
import {HttpService} from '../services/http.service';
import {LoaderService} from '../services/loader.service';

/**
 * A simple factory which creates a pre-configured, custom Http service instance
 *
 * @param {XHRBackend} backend
 * @param {RequestOptions} options
 * @param {NotificationsService} notificationService
 * @param {LoaderService} loaderService
 * @returns {HttpService}
 */
const httpServiceFactory = (backend: XHRBackend,
                            options: RequestOptions,
                            notificationService: NotificationsService,
                            loaderService: LoaderService) => {
  return new HttpService(backend, options, notificationService, loaderService);
};

export {httpServiceFactory};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/utils/http-service-factory.factory.ts